<template>
  <div class="identidade-visual-logo-intro-content" id="identidade-visual-logo-introducao" data-search-anchor>   
    <div class="idt-vis-logo-intro-content">      
      <h1 class="identidade-visual-logo-intro-title">{{ logointroTitle }}</h1>           
            
      <div class="idt-vis-logo-icon-wrapper">
        <p class="identidade-visual-logo-intro-description">{{ logointroDescription }}</p>
        <div class="identidade-visual-logo-intro-fica-a-dica">        
          <p class="fica-a-dica">{{ logointroDescription1 }}</p>
          <p class="identidade-visual-logo-intro-description2">{{ logointroDescription2 }}</p>
          <p class="identidade-visual-logo-intro-description2" v-html="logointroDescription3"></p>
        </div>
      </div>      
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import VisualIdentityPageMixin from '@/mixins/visual-identity-page-mixin'
import { VisualIdentityPageStore } from '@/store/visual-identity-page/visual-identity-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LogoIntroSection extends Mixins(VisualIdentityPageMixin) {
  visualIdentityPageStore: PageStoreContract = getModule(VisualIdentityPageStore, this.$store)

  get logointroTitle(): string {
    return this.getElementText(1, 0)
  }

  get logointroDescription(): string {
    return this.getElementText(1, 1)
  }

  get logointroDescription1(): string {
    return this.getElementText(1, 2)
  }

  get logointroDescription2(): string {
    return this.getElementText(1, 3)
  }

  get logointroDescription3(): string {
    const texto = this.getElementText(1, 4)
    const palavra = 'Guia de Marcas'
    const url = 'https://guiademarcas.globo/'
    const link = `<a href="${url}" target="_blank" >${palavra}</a>`;
    return texto.replace(palavra, link)
  }

  async getVisualIdentityPage(): Promise<void> {
    await this.visualIdentityPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.visualIdentityPageStore.isLoading) {
      await this.getVisualIdentityPage()
    }
  }
}
</script>

<style lang="scss">
.identidade-visual-logo-intro-content {
  display: flex;
  align-items: center;  
  flex-direction: column;
  width: 100%;
}

.idt-vis-logo-intro-content {
  width: 100%;
  display: grid;
  grid-template-columns: 50% 50%;
  max-width: 1032px;
}

.identidade-visual-logo-intro-title {  
  font-size: 65px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;  
  margin: 0;

  width: 440px;
  height: 245px;
  white-space: pre-line;
}

.identidade-visual-logo-intro-fica-a-dica {  
  margin: 0;   
}

.idt-vis-logo-icon-wrapper{
  width: 488px;  
}

.identidade-visual-logo-intro-description,
.fica-a-dica {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;  
}

.identidade-visual-logo-intro-description2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  margin-top: 0; 
  width: 488px;    
}

</style>
